import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListMobileNumberCell } from '@app/feature/user/user-list/user-list-mobile-number.cell';
import { UserListMobileNumberHeader } from '@app/feature/user/user-list/user-list-mobile-number.header';

export const CustomerUserListMobileNumberColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['mobileNumber']
> = {
  enableSorting: false,
  header: UserListMobileNumberHeader,
  cell: UserListMobileNumberCell,
};
